import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { trackContact } from '../utils/metaPixel';
export const FooterSection = () => {
  return <footer className="bg-primary text-white pt-24 pb-12 relative overflow-hidden" data-id="element-37">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-accent/20 rounded-full blur-[120px] pointer-events-none" data-id="element-38" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-41">
            Empieza a sentirte bien <br className="hidden md:block" data-id="element-42" />
            <span className="text-accent" data-id="element-43">desde hoy mismo.</span>
          </h2>

          <p className="text-lg md:text-xl text-white/80 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-44">
            De forma rápida, fácil y sin tener que sufrir te ayudaremos a
            alcanzar el objetivo deseado. Consulta disponibilidad para tu sesión
            personalizada de salud y bienestar. Sin vueltas, sin efectos
            secundarios, con eficacia real.
          </p>

          <a href="https://wa.link/r4i31b" target="_blank" rel="noopener noreferrer" onClick={trackContact} className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-whatsapp text-white rounded-full font-bold text-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 mb-16" data-id="element-45">
            <WhatsAppIcon className="w-6 h-6" data-id="element-46" />
            Quiero mi Sesión por WhatsApp
          </a>
        </motion.div>

        <div className="border-t border-white/10 pt-12 mt-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-47">
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-48">
            <img src="https://cdn.magicpatterns.com/uploads/uqu2kUwrDtAghAbBg9J3eh/Diseno_sin_titulo_(85).png" alt="La Conexión Cuántica Logo" className="h-14 object-contain bg-white/90 p-2 rounded-lg" data-id="element-49" />
            <p className="text-sm text-white/60 text-center md:text-left max-w-md" data-id="element-50">
              LA CONEXIÓN CUÁNTICA © 2024. Facilitación de Salud y Bienestar.
              Basado en Método INTEGRA® por Ricardo Eiriz.
            </p>
          </div>

          <a href="https://www.instagram.com/laconexioncuantica.oficial/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/80 hover:text-accent transition-colors" data-id="element-51">
            <InstagramIcon className="w-5 h-5" data-id="element-52" />
            <span data-id="element-53">@laconexioncuantica.oficial</span>
          </a>
        </div>
      </div>
    </footer>;
};